var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('video',{staticClass:"tencent-player",attrs:{"id":_vm.tcPlayerId,"preload":"auto","controlBar":{volumePanel:false},"playsinline":"","webkit-playsinline":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }